<div class="row pl-3 mt-4">
    <div class="col-lg-8 col-md-10 col">
        <div class="row  pt-4">
            <!-- //API GetAllWithExtraAttributes -->
            <div class="col-md-6 col-12 mb-4"
                *ngFor="let extraAttr of extraAttributeObject.value.filteredExtraAttributes">
                <div>
                    <div>
                        <label>{{extraAttr.name | localize}}</label>
                    </div>


                    <!-- //API GetAllEntitiesByTypeCodeWithPaging -->
                    <div class="d-flex align-items-center">

                        <div class="wide-drop-down d-flex flex-grow-1"
                            *ngIf="extraAttr?.paginationSetting && extraAttr?.acceptMultipleValues && extraAttr.isLookup">
                            <div class="flex-grow-1 mr-1">
                                <p-multiSelect (onChange)="onAnyInputChange()"
                                    [options]="extraAttr.paginationSetting.list" [styleClass]="'w-100'"
                                    [(ngModel)]="extraAttr.selectedValues" name="extraAttr_{{extraAttr.name}}"
                                    [placeholder]="('Select') + ' ' + extraAttr.name">
                                    <!-- (onChange)="multiValuesExtraAttributeOnChange($event,extraAttr)" -->
                                </p-multiSelect>
                            </div>
                        </div>

                        <div class="wide-drop-down flex-grow-1 "
                            *ngIf="extraAttr?.paginationSetting && !extraAttr?.acceptMultipleValues && extraAttr.isLookup">
                            <p-dropdown (onChange)="onAnyInputChange()" [options]="extraAttr.paginationSetting.list"
                                [styleClass]="'w-100'" [(ngModel)]="extraAttr.selectedValues"
                                name="extraAttr_{{extraAttr.name}}" [placeholder]="('Select') + ' ' + extraAttr.name">
                                <!-- (onChange)="singleValueExtraAttributeOnChange($event,extraAttr)" -->
                            </p-dropdown>
                        </div>

                        <div class="flex-grow-1 position-relative"
                            *ngIf="extraAttr.dataType === 'string' && !extraAttr.isLookup">
                            <input type="text" name="{{extraAttr.name}}" placeholder="{{extraAttr.name}}"
                                class="form-control" [(ngModel)]="extraAttr.selectedValues"
                                style="background-color: #EEEEEE !important; border: none !important"
                                (ngModelChange)="onAnyInputChange()" />
                            <i class="pi pi-times position-absolute" style="right: 10px; top: 10px; cursor: pointer;"
                                *ngIf="extraAttr.selectedValues" (click)="clearExtraAttr(extraAttr)"></i>
                            <!-- (keyup)="notLookupExtraAttributeOnChange($event.target.value,extraAttr)" -->
                        </div>

                        <div class="flex-grow-1"
                            *ngIf="extraAttr.dataType === 'boolean' || extraAttr.dataType === 'bit' ">
                            <div class="radio-inline mt-2">
                                <label class="radio radio-accent radio-primary mr-4"
                                    for="extraAttr{{extraAttr.name}}_1">
                                    <input (ngModelChange)="onAnyInputChange()" type="radio"
                                        name="extraAttr_{{extraAttr.name}}" id="extraAttr{{extraAttr.name}}_1"
                                        [value]="'true'" [(ngModel)]="extraAttr.selectedValues" style="background-color: #EEEEEE !important;
                         border: none !important" />
                                    <!-- (click)="notLookupExtraAttributeOnChange('true',extraAttr)" -->
                                    {{ "Yes" | localize }}
                                </label>
                                <label class="radio radio-accent radio-primary" for="extraAttr{{extraAttr.name}}_0">
                                    <input (onChange)="onAnyInputChange()" type="radio"
                                        name="extraAttr_{{extraAttr.name}}" id="extraAttr{{extraAttr.name}}_0"
                                        [value]="'false'" [(ngModel)]="extraAttr.selectedValues" style="background-color: #EEEEEE !important;
                         border: none !important">
                                    <!-- (click)="notLookupExtraAttributeOnChange('true',extraAttr)" -->
                                    {{ "No" | localize }}
                                </label>
                                <a *ngIf="extraAttr.selectedValues" class="ml-5 pointer text-black-50 font-weight-bold"
                                    (click)="extraAttr.selectedValues = null">
                                    Reset
                                </a>

                            </div>
                        </div>


                        <div class="flex-grow-1 position-relative" *ngIf="extraAttr.dataType === 'Datetime'">
                            <p-calendar #calendarRef [(ngModel)]="extraAttr.selectedValues" [showIcon]="false"
                                [showOtherMonths]="true" [selectOtherMonths]="true" [placeholder]="extraAttr.name"
                                (ngModelChange)="onAnyInputChange()" appendTo="body"
                                [inputStyle]="{ 'background-color': '#EEEEEE', 'border': 'none' }"
                                styleClass="w-100"></p-calendar>
                            <i class="pi pi-times position-absolute" style="right: 10px; top: 10px; cursor: pointer;"
                                *ngIf="extraAttr.selectedValues" (click)="clearExtraAttr(extraAttr)"></i>

                        </div>


                        <div class="flex-grow-1" *ngIf="extraAttr.dataType === 'Numeric' ">
                            <input (ngModelChange)="onAnyInputChange()" type="number" name="{{extraAttr.name}}"
                                placeholder="{{extraAttr.name}}" class="form-control" id="extraAttr{{extraAttr.name}}"
                                [(ngModel)]="extraAttr.selectedValues" style="background-color: #EEEEEE !important;
                                                                    border: none !important">
                            <!-- (keyup)="notLookupExtraAttributeOnChange($event.target.value,extraAttr)" -->
                        </div>

                        <a class="border rounded text-primary add-new-lookup-btn ml-3"
                            *ngIf="extraAttr.isLookup && extraAttr.allowAddNew">
                            <!-- (click)="openCreateNewAppEntityModal(extraAttr)" -->
                            <i class="fas fa-pen"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div>
                <small class="ml-2"
                    *ngIf="entityType=='Item'  && !extraAttributeObject.value?.filteredExtraAttributes?.length && !entityObjectTypeId">{{
                    "PleaseSelectAProductTypeFirst" | localize }}</small>
                <small class="ml-2" *ngIf="!extraAttributeObject.value?.filteredExtraAttributes?.length &&
                           (entityType === 'Item' ? !!entityObjectTypeId : true)">
                    {{"No" | localize }} {{ extraAttributeObject.value?.header }} {{"Attributes" | localize }}
                </small>
            </div>
        </div>
    </div>
</div>